import { useEffect, useState } from "react";
import { api } from "./api";

let cache = null;
let pending = null;

export function useCategories() {
  const [cats, setCats] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    pending = pending || api.get("/public/categories").then((r) => (cache = r.data.filter((c) => !c.parent_id)));
    pending.then(setCats).catch(() => { pending = null; setTimeout(() => { pending = pending || api.get("/public/categories").then((r) => (cache = r.data.filter((c) => !c.parent_id))); pending.then(setCats).catch(() => { pending = null; }); }, 3000); });
  }, []);
  return cats;
}

export function useFetch(path, deps = []) {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  const [tick, setTick] = useState(0);
  useEffect(() => {
    let alive = true;
    setState((s) => ({ ...s, loading: true }));
    api
      .get(path)
      .then((r) => alive && setState({ data: r.data, loading: false, error: null }))
      .catch((e) => alive && setState({ data: null, loading: false, error: e }));
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, tick, ...deps]);
  return { ...state, reload: () => setTick((t) => t + 1) };
}
